import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../../../core/services/AuthServices/auth.service";
import {Subscription} from "rxjs";
import {EmployerLoginResponse} from "../../Models/EmployerLoginResponse";
import {HttpErrorResponse} from "@angular/common/http";
import {LoginReq} from "../../../../core/models/LoginReq";
import {TokenResponse} from "../../../../core/models/TokenResponse";
import {TokenUserProfile} from "../../../../core/models/TokenUserProfile";
import {AuthUtil} from "../../Utils/AuthUtil";

@Component({
  selector: 'app-employer-login',
  templateUrl: './employer-login.component.html',
  styleUrls: ['./employer-login.component.scss']
})
export class EmployerLoginComponent implements OnInit, OnDestroy {
  employerLoginForm: UntypedFormGroup;
  submitted = false;
  error = '';
  returnUrl: string;
  private subscriptions: Subscription[] = [];
  showEmployerOptions: boolean;
  employersForLogin: EmployerLoginResponse[] = [];
  loading: boolean;

  // set the current year
  year: number = new Date().getFullYear();

  // convenience getter for easy access to form fields
  get f() {
    return this.employerLoginForm?.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    // check if the employer is already logged in
    if(this.authenticationService?.isLoggedIn()) {
      const currUser: TokenUserProfile = this.authenticationService?.currentUser();
      switch (currUser?.user?.user_category?.category){
        case 'EMPLOYER' :
          this.router.navigateByUrl('/employer/employer-dashboard').then();
          break;
        default:
          this.authenticationService?.logOut();
      }
    }
    this.employerLoginForm = this.formBuilder.group({
      tin: ['', [Validators.required]],
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

  }

  onSubmit(value) {
    const loginReq: LoginReq = new LoginReq();
    this.error = null;
    this.loading = true;
    loginReq.username = value.username;
    loginReq.password = value.password;
    this.subscriptions.push(this.authenticationService.sendLoginRequest(loginReq).subscribe(
      {
        next: (response: TokenResponse) => {
          this.loading = false;
          const tokenUserProfile: TokenUserProfile = AuthUtil.insertAuthenticationTokenToSessionStorage(response);
          this.authenticationService.userProfile.next(tokenUserProfile);
          this.navigateToRespectivePages();
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          if(error.error.detail)
          {
            this.error = error.error.detail
          }
          else {
            this.error = 'An Error Occurred Please Try Again'
          }
          console.table(error.error)
        }
      }
    ))
  }

  getEmployersByTin() {
    this.error = null;
    this.showEmployerOptions = false;
    this.subscriptions.push(this.authenticationService.getEmployerLoginResponseByTin(this.f.tin.value).subscribe(
      {
        next: (response: EmployerLoginResponse[]) => {
          console.log('response-back');
          this.employersForLogin = response;
          this.showEmployerOptions = true;
        },
        error: (errorResponse: HttpErrorResponse) => {
          if(errorResponse?.error?.detail)
          {
            this.error = errorResponse.error.detail
          }
          else {
            this.error = 'An Error Occurred Please Try Again'
          }
        }
      }
    ));
  }

  navigateToRespectivePages() {
    const userProfile: TokenUserProfile = AuthUtil.getUser()
    if(userProfile != null)
    {
      if (userProfile?.user?.user_category?.category === 'EMPLOYER') {
        this.router.navigateByUrl('/employer/employer-dashboard').then()
      } else {
        this.authenticationService.logOut();
        this.error = 'Invalid Category Please Contact Us For Further Support';
      }
    }
    else {
      this.authenticationService.logOut();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
